import { useEffect, useState } from 'react';
import { products as staticProducts } from '../data/products';

const staticById = new Map(staticProducts.map((product) => [product.id, product]));

const useCatalogProducts = () => {
  const [products, setProducts] = useState(staticProducts);

  useEffect(() => {
    const controller = new AbortController();
    fetch('/api/products', { signal: controller.signal })
      .then(async (response) => {
        if (!response.ok) throw new Error('Catalog unavailable');
        return response.json();
      })
      .then((data) => {
        if (!Array.isArray(data.products)) return;
        setProducts(data.products.map((product) => ({
          ...staticById.get(product.id),
          ...product,
          image: product.image || staticById.get(product.id)?.image,
        })));
      })
      .catch((error) => {
        if (error.name !== 'AbortError') console.warn('Using bundled product catalog');
      });
    return () => controller.abort();
  }, []);

  return products;
};

export default useCatalogProducts;
